/* eslint-disable no-unused-vars,camelcase */
import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import { SectionTitle } from '../components/Forms'
import queryString from 'query-string'
import store from 'store'

// Import Custom Components
import SEO from '../components/SEO'
import Container from '../components/Container'
import Sections from '../components/Sections/Sections'
import Layout from '../components/Layout'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import Body from '../components/Body'
import Intro from '../components/Intro'
import Hero from '../components/Hero'
import Header from '../components/Header'
import { siteSettingsReducer } from '../utils/util'

const DefaultTemplate = ({ location, children, data, pageContext: { brain } }) => {
  // Callback doesn't need nav etc, so return early
  if (location.pathname === '/callback') {
    return (
      <div>
        <Container>{children} </Container>
      </div>
    )
  }

  if (location.search) {
    const { discountCode } = queryString.parse(location.search);
    if (discountCode) {
      store.set('discountCode', discountCode);
    }
  }


  // if data does not exist then return null to avoid errors
  if (!data) return null

  // deconstruct out the contentful data attributes and objects
  const { seo, headline, subHeading, centerHeadline, body, hero } = data.contentfulPage

  let pageSections = data.contentfulPage.pageSections;
  let siteSettings = {};
  if (data.allContentfulSiteSettings) {
    // convert to object with slug as keys for easier reference later
    siteSettings = siteSettingsReducer(data.allContentfulSiteSettings.edges);
  }

  // Scroll page to top on render
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, [])

  return (
    <Layout siteSettings={siteSettings}>
      <Helmet>
        <title>{`Home - ${config.siteTitle}`}</title>
        <meta name="google-site-verification" content="YoHjCjY1YiI9wzYXerz24ZaoryqHDUAeJw-tfYO-YIc" />
      </Helmet>
      {/**
       * SEO
       * Requires the seo data object. If no seo object is added then it will
       * default to a few simple items that are defined in /utils/siteConfig.js file
       * which is referenced in the gatsby-config.js file
       *  */}
      <SEO data={seo} pagePath={location.pathname} />
      <Body>
        <Hero data={hero} />
        <div className="content">
          {/**
           * I used your Container to wrap the page template.
           * which, as you defined, renders everything out as children of that component
           */}
          <Container>
            {/**
             * Direct Page Components
             * Here I'm just using the data from the page. Notice that I'm using a ternary
             * to make the visibiliy of these elements optional. The idea is that they should not
             * show up at all if they don't have values in contentful.
             */}
            {body || headline || subHeading ? (
              <>
                <Intro>
                  <SectionTitle centerHeadline={centerHeadline}>
                    {headline ? <Header>{headline}</Header> : null}
                    {subHeading ? <h2>{subHeading}</h2> : null}
                  </SectionTitle>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: body ? body.childMarkdownRemark.html : null,
                    }}
                  />
                </Intro>
              </>
            ) : null}
            {/**
             * Sections
             * Page sections are where all sections and blocks are rendered. This is typically the
             * main body content of the page... where all the real magic happens.
             */}
            <Sections brain={brain} data={pageSections} />
          </Container>
        </div>
      </Body>
    </Layout>
  )
}

/**************************************************
 * Add the data layer with GraphQL
 * DO NOT Name the query. If you do,
 * be aware that duplicate query names will
 * cause a build error
 *************************************************/

export const pageQueryGraphQL = graphql`
  query($slug: String) {
    # Include the page data using the slug defined in contentful
    contentfulPage(slug: { eq: $slug }) {
      ...page
    }
    allContentfulSiteSettings (
        filter: { slug: { ne: "example-do-not-delete" } }
    ) {
        edges {
            node {
                ...siteSettings
            }
        }
    }
  }
`

export default DefaultTemplate
